(function() {
  var sliders = {};
  window.rs_goSlide = function(id, i) {
    if (!sliders[id]) sliders[id] = { idx: 0 };
    var track = document.getElementById(id + '-track');
    var dots = document.getElementById(id + '-dots');
    if (!track) return;
    var count = track.children.length;
    sliders[id].idx = Math.max(0, Math.min(i, count - 1));
    track.style.transform = 'translateX(-' + (sliders[id].idx * 100) + '%)';
    if (dots) dots.querySelectorAll('.slider-dot').forEach(function(d, j) {
      d.classList.toggle('active', j === sliders[id].idx);
    });
  };
  window.rs_moveSlider = function(id, dir) {
    if (!sliders[id]) sliders[id] = { idx: 0 };
    var track = document.getElementById(id + '-track');
    var count = track ? track.children.length : 0;
    window.rs_goSlide(id, (sliders[id].idx + dir + count) % count);
  };
})();
